import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home--sprite",
  "use": "home--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home--sprite\">\n    <path d=\"M9.6 22V14.9412H14.4V22H20.4V12.5882H24L12 2L0 12.5882H3.6V22H9.6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol